import styled from "styled-components";

export const Container = styled.div`
  box-shadow: rgba(0, 0, 0, 0.15) -3px 3px 5px 0px;
  padding: 15px;
  background-color: #fff;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  color: #000000de;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 28px;
  font-weight: 700;
`;

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface IProps {
  bgColor: string;
}

export const Card = styled.div<IProps>`
  background-color: ${(props) => props.bgColor || "#37b394"};
  display: flex;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  flex-direction: column;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  flex: 1;
  margin: 10px;
`;

export const CardTitle = styled.span`
  font-size: 20px;
  color: #fff;
`;

export const CardValue = styled.span`
  font-size: 30px;
  margin: 10px 0;
  color: #fff;
`;
